// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"6aae4d4d","815":"c814ff11"}[chunkId] + ".chunk.css";
};